import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import App from './App';

export const ROOT_ELEMENT_ID = 'kodif-chat-widget-container';

export const root = ReactDOM.createRoot(document.getElementById(ROOT_ELEMENT_ID));

root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);
